/* __next_internal_client_entry_do_not_use__ useCardListContext,Default auto */ import { jsx as _jsx } from "react/jsx-runtime";
// Global
import { createContext, useContext } from 'react';
import { tv } from 'tailwind-variants';
// Local
import { withStandardComponentWrapper } from 'helpers/HOC';
import { parseStyleParams } from 'lib/utils/style-param-utils';
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
import { getTestProps } from 'lib/testing/utils';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
// Create context for column count
const CardListContext = /*#__PURE__*/ createContext('1');
// Hook to use the context
export const useCardListContext = ()=>useContext(CardListContext);
const CardList = (props)=>{
    const isEditing = useIsEditing();
    const { DynamicPlaceholderId, RenderingIdentifier } = props?.params || {};
    const phKey = `cardlist-${DynamicPlaceholderId}`;
    const styles = parseStyleParams(props.params, [
        'cards'
    ]);
    const colCount = styles?.cards?.cardsPerRow;
    /*
   * Rendering
   */ const { base, card } = TAILWIND_VARIANTS({
        colCount
    });
    return /*#__PURE__*/ _jsx(CardListContext.Provider, {
        value: colCount,
        children: /*#__PURE__*/ _jsx("section", {
            "data-component": "authorable/shared/lists/cardlist",
            ...editingHydrationProps(isEditing),
            id: RenderingIdentifier,
            ...getTestProps(`component-cardlist-${props?.rendering?.uid}`),
            children: /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                name: phKey,
                rendering: props.rendering,
                // Wrap the component in a <ul>.
                // If there are no components it won't render anything on the live page
                // It also ensures that when editing in Page Builder, it will show the help text outside of the <ul>
                render: (components)=>/*#__PURE__*/ _jsx("ul", {
                        className: base(),
                        "aria-label": "List of cards",
                        children: components.map((comp, index)=>/*#__PURE__*/ _jsx("li", {
                                className: card(),
                                role: "listitem",
                                ...getTestProps(`card-${index}`),
                                children: comp
                            }, index))
                    })
            })
        })
    });
};
export const Default = withStandardComponentWrapper(CardList, false);
const TAILWIND_VARIANTS = tv({
    defaultVariants: {
        colCount: '1'
    },
    slots: {
        base: [
            'gap-6',
            'grid',
            'grid-cols-1'
        ],
        card: [
            'flex',
            'flex-col'
        ]
    },
    variants: {
        colCount: {
            '1': {
                base: [
                    'lg:grid-cols-1'
                ]
            },
            '2': {
                base: [
                    'md:grid-cols-2'
                ]
            },
            '3': {
                base: [
                    'lg:grid-cols-3'
                ]
            },
            '4': {
                base: [
                    'lg:grid-cols-4'
                ]
            }
        }
    }
});
